import { useAppContext } from '../../context/AppContext';
import { fetchRunBatch } from '../../services';
import { useState } from 'react';

function initialState() {
  return {
    invoiceDate: '',
    counter: 0,
    submitted: false,
    saving: false,
  };
}

export const BatchStatic = ({ isOpen, onClose }) => {
  const { token, base_url, showStatus } = useAppContext();
  const [state, setState] = useState(initialState);

  if (!isOpen) return null;

  const resetAndClose = () => {
    setState(initialState());
    onClose?.();
  };

  const setField = (key, value) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const runBatch = async (e) => {
    e.preventDefault();
    if (!state.invoiceDate) {
      showStatus('error', 'Select an invoice date before running the batch.');
      return;
    }

    setField('saving', true);
    try {
      await fetchRunBatch(token, base_url, {
        invoiceDate: state.invoiceDate,
        counter: Number(state.counter),
      });
      setState((prev) => ({
        ...prev,
        submitted: true,
        invoiceDate: '',
        counter: 0,
      }));
      showStatus('success', 'Batch submitted. We will email you when it is complete.');
    } catch (error) {
      showStatus('error', error.message ?? 'Failed to submit batch.');
    } finally {
      setField('saving', false);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={resetAndClose} aria-hidden="true" />
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="batch-static-modal-title">
        <div className="modal-content batch-modal-content">
          <h2 id="batch-static-modal-title" className="modal-title">
            {!state.submitted ? "Let's get your batch running" : 'Batch running...'}
          </h2>
          <div className="divider" />

          {!state.submitted ? (
            <form onSubmit={runBatch} className="batch-modal-form">
              <div className="form-group">
                <label className="form-label" htmlFor="batch-static-invoice-date">
                  Select an Invoice Date
                </label>
                <input
                  id="batch-static-invoice-date"
                  className="form-input"
                  type="date"
                  value={state.invoiceDate}
                  onChange={(e) => setField('invoiceDate', e.target.value)}
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="batch-static-counter">
                  Add a Starting Number
                </label>
                <input
                  id="batch-static-counter"
                  className="form-input"
                  type="number"
                  min="0"
                  value={state.counter}
                  onChange={(e) => setField('counter', e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary batch-modal-submit"
                disabled={state.saving}
              >
                {state.saving ? 'Submitting…' : 'Run Batch'}
              </button>
            </form>
          ) : (
            <p className="modal-body batch-modal-message">
              We will send you an email when the batch is complete.
            </p>
          )}

          <button
            type="button"
            className="btn btn-secondary batch-modal-close"
            onClick={resetAndClose}
          >
            {!state.submitted ? 'Cancel' : 'Close'}
          </button>
        </div>
      </div>
    </>
  );
};
